import { createReducer, on } from '@ngrx/store';
import {
  BrandsByApplianceState,
  BrandsState,
  initialBrandState,
} from '@sky/util-models';
import {
  remoteDataError,
  remoteDataLoading,
  remoteDataOK,
} from '@common/util-models';

import * as BrandsActions from './brands.actions';

export const BRANDS_KEY = 'brandsByAppliance';

export interface BrandsPartialState {
  readonly [BRANDS_KEY]: BrandsByApplianceState;
}

export const initialBrandsState: BrandsState = initialBrandState;

export const brandsReducer = createReducer(
  {} as BrandsByApplianceState,
  on(BrandsActions.loadBrands, (state, { applianceCode }) => ({
    ...state,
    [applianceCode]: {
      ...initialBrandsState,
      remoteState: remoteDataLoading(),
    },
  })),

  on(BrandsActions.loadBrandsSuccess, (state, { brands, applianceCode }) => ({
    ...state,
    [applianceCode]: {
      brands,
      remoteState: remoteDataOK(null),
    },
  })),

  on(BrandsActions.loadBrandsFailure, (state, { error, applianceCode }) => ({
    ...state,
    [applianceCode]: {
      brands: [],
      remoteState: remoteDataError(error),
    },
  }))
);
